const modal_form = require('civicsViews/dynamic_form/v_lov_dynamic_form');
const CN = require('civicsUtils/constants');
const inspection_model = require('civicsModels/inspection_model');
const request_inspection_model = require('civicsModels/request_inspection_model');
const my_assignments_collection = require('civicsCollections/portal/assignment_view_collection_card_view');
const review_model = require('civicsModels/review_model');
const log_model = require('civicsModels/cdr_log_model');
const ViewManager = require('civicsUtils/view_manager');
const AvailableFeatures = require('civicsUtils/available_features');

//this is an extension to the inspection & review row view. This will not function as a stand alone file.
define(function (require) {
	return {
		cancelAssignment: function (data, callbackData) {
			ViewManager.loading(true);
			var logModel = new log_model();
			logModel.set(data);
			//set inspection or review to the model ID
			logModel.set(this.assignmentType, this.model.get('id'));
			logModel.set({
				application: this.model.get('instrument.id'),
				logType: this.logTypes[callbackData.logType],
				StartDateTime: new Date($.now()).yyyymmdd(),
			});
			logModel._dataType = this.model.get('_cdrType');
			logModel.save().done(() => {
				this.updateAssignment({
					assignedToProvider: { id: 1 },
					scheduledDateTime: CN.DATE_TIME_MIN_VAL,
					callDateTime: CN.DATE_TIME_MIN_VAL,
					timePreference: ''
				});
			}).fail((response, status, xhrResponse) => {
				if (response.responseJSON &&
					response.responseJSON.responseStatus &&
					response.responseJSON.responseStatus.message &&
					response.responseJSON.responseStatus.message.indexOf('You do not have access to add a log to this instrument') != -1) {
					ViewManager.openAlert(i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.DO_NOT_HAVE_ACCESS_ERROR'));
				}
				else {
					ViewManager.errorToWindow(response);
				}
			});
		},
		scheduleSpecialInstructions: function (data, callbackData) {
			ViewManager.loading(true);
			if (callbackData && callbackData.reschedule === true && data.scheduledDateTime == '') {
				data.scheduledDateTime = CN.DATE_TIME_MIN_VAL;
			}
			var inspection = new request_inspection_model();

			inspection.set(data);
			inspection.set({
				id: this.model.id
			});
			inspection.formatUrlRoot(this.model.get('_cdrType'));

			//force a post if this is a new request, use put if it's a reschedule
			var options = {};
			// if (!this.hasScheduledDate) {
			// 	options.type = 'POST';
			// }
			inspection.save().done((response,status, xhr) => {
				$.when(this.fetchUpdatedAssignment()).done(() => {
					if(this.processCardConfig) {
						this.processCardConfig();

					}

					if(this.displayCards) {
						this.displayCards();
					}
					ViewManager.loading(false, null, false);
				});
				
				this.closeModal();
			})
			.fail((response, status, xhr) => {
				ViewManager.errorToWindow(response);
				ViewManager.loading(false, null, false);
			})

		},
		updateAssignment: function (data, callbackData) {
			ViewManager.loading(true);
			//if the date has been blanked out in teh form, we need to set it to the minimum value or else it
			//won't be saved on the server, and any previously existing data will appear instead.
			if (callbackData && callbackData.reschedule === true && data.scheduledDateTime == '') {
				data.scheduledDateTime = CN.DATE_TIME_MIN_VAL;
				data.callDateTime = CN.DATE_TIME_MIN_VAL;
			}
			var assignment;
			if (this.assignmentType == 'review') {
				assignment = new review_model();
			} else {
				assignment = new inspection_model();
			}
			assignment.formatUrlRoot(this.model.get('_cdrType'));
			assignment.set({
				id: this.model.get('id'),
			});
			assignment.set(data);
			ViewManager.loading(true);
			assignment.save()
				.done((response, status, xhr) => {
					$.when(this.fetchUpdatedAssignment()).done(() => {
						if(this.processCardConfig) {
							this.processCardConfig();

						}

						if(this.displayCards) {
							this.displayCards();
						}
						ViewManager.loading(false, null, false);
					});

					this.closeModal();
				})
				.fail((response, status, xhr) => {
					ViewManager.errorToWindow(response);
					ViewManager.loading(false, null, false);
				})
		},
		//since workflows can affect the data on an inspection/review, we need to do a full re-fetch using the assignments collection
		//so the portlet appropriately re-renders the view. The save in the updateAssignment function returns the same updated data,
		//but it is not processed how the portlet expects it. So we fetch it again.
		fetchUpdatedAssignment: function () {

			if(this.instrumentDetailView) {
				location.reload(); // if we're using the action buttons in the instrument view, we don't want to call the assignments. just reload.
				return;
			}

			var myAssignments = new my_assignments_collection();
			var extendedFilter = {
				And: []
			};
			extendedFilter.And.push({ operator: 'Equal', property: 'assignmentType', value: this.model.get('assignmentType') })
			extendedFilter.And.push({ operator: 'Equal', property: 'id', value: this.model.get('id') });
			extendedFilter.And.push({ operator: 'Equal', property: 'AssignedToProvider.Id', value: ViewManager.currentUser().get('contactId.id') });
			myAssignments.urlParameters = {
				extendedFilter: extendedFilter
			}
			var promise = myAssignments.fetch({
				success: (collection, response, options) => {
					if (collection && collection.models && collection.models.length == 1) {
						this.model.set(collection.models[0].toJSON());
					} else {
						//if we didn't get exactly one model back, we need to just refresh the page.
						//this will always be the case when cancelling/declining
						location.reload();
					}
				},
				error: (collection, response, options) => {
					ViewManager.errorToWindow(response);
					ViewManager.loading(false);
				}
			});
			return promise;
		},
		rescheduleAssignmentClicked: function (e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			if (this.assignmentType == 'review') {
				this.openModalForm({
					elements: this.reviewRescheduleFormJSON(),
					callback: this.updateAssignment.bind(this),
					titleText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.RESCHEDULE'),
					callbackData:{reschedule:true}
				});
			} else {
				this.openModalForm({
					elements: this.inspectionRescheduleFormJSON(),
					callback: AvailableFeatures.SpecialInstructions() ? this.scheduleSpecialInstructions.bind(this) : this.updateAssignment.bind(this),
					titleText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.RESCHEDULE'),
					callbackData: { reschedule: true }

				});
			}
		},
		cancelAssignmentClicked: function (e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			if (this.assignmentType == 'review') {
				this.openModalForm({
					elements: this.reviewCancelFormJSON(),
					callback: this.cancelAssignment.bind(this),
					titleText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.CANCEL_REVIEW'),
					callbackData: { logType: 'cancelReview' },
					saveText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.CANCEL_REVIEW_BUTTON'),
					cancelText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.BACK')
				});
			} else {
				this.openModalForm({
					elements: this.inspectionCancelFormJSON(),
					callback: this.cancelAssignment.bind(this),
					titleText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.CANCEL_INSPECTION'),
					callbackData: { logType: 'cancelInspection' },
					saveText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.CANCEL_REQUEST'),
					cancelText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.BACK')
				});
			}
		},
		acceptAssignmentClicked: function (e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			if (this.assignmentType == 'review') {
				this.openModalForm({
					elements: this.reviewScheduleFormJSON(),
					callback: this.updateAssignment.bind(this),
					titleText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SCHEDULE'),
					callbackData: { reschedule: false }
				});
			} else {
				this.openModalForm({
					elements: this.inspectionScheduleFormJSON(),
					callback: AvailableFeatures.SpecialInstructions ? this.scheduleSpecialInstructions.bind(this) : this.updateAssignment.bind(this),
					titleText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SCHEDULE'),
					callbackData: { reschedule: false }
				});
			}
		},
		declineAssignmentClicked: function (e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			if (this.assignmentType == 'review') {
				this.openModalForm({
					elements: this.reviewDeclineFormJSON(),
					callback: this.cancelAssignment.bind(this),
					titleText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.DECLINE_REVIEW'),
					callbackData: { logType: 'declineReview' },
					saveText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.DECLINE_REVIEW'),
					cancelText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.BACK')
				});
			} else {
				this.openModalForm({
					elements: this.inspectionDeclineFormJSON(),
					callback: this.cancelAssignment.bind(this),
					titleText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.DECLINE_INSPECTION'),
					callbackData: { logType: 'declineInspection' },
					saveText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.DECLINE_REQUEST'),
					cancelText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.BACK')
				});
			}

		},
		openModalForm: function (formData) {//elements, callback, titleText, saveText, cancelText, callbackData) {
			if (this.modalFormView) {
				this.modalFormView.destroy();
			}
			this.modalFormView = new modal_form({
				elements: formData.elements,
				saveCallback: formData.callback.bind(this),
				saveCallbackData: formData.callbackData,
				cancelCallback: this.closeModal.bind(this),
				titleText: formData.titleText,
				saveText: formData.saveText ? formData.saveText : i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SAVE'),
				cancelText: formData.cancelText ? formData.cancelText : i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.CANCEL'),
				isModal: true
			});
			this.modalRegion.show(this.modalFormView);
			this.modalRegion.showModal();
		},
		closeModal: function (e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			if (this.modalFormView) {
				this.modalFormView.destroy();
			}
		},
		openElectronicPlanClicked: function(e) {
			if(e) {
				e.preventDefault();
				e.stopPropagation();
			}

			window.open(this.model.get('ElectronicPlanReviewUrl'));
			window.focus();
		},
		reviewScheduleFormJSON: function () {
			return [
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SCHEDULED_DATE'),
					bind: 'scheduledDateTime',
					dataType: 'System.DateTime',
					format: 'date',
					type: 'TextBox',
					isRequired: true,
					value: this.model.get('scheduledDateTime')
				}
			]
		},
		reviewRescheduleFormJSON: function () {
			return this.reviewScheduleFormJSON();
		},
		reviewDeclineFormJSON: function () {
			return [
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.ABOUT_TO_DECLINE_REVIEW') + '</br></br>',
					type: 'label',
					isEnabled: true,
					isVisible: true,
					isHtml: true
				},
				{
					type: 'Panel',
					elements: [
						{
							text: this.model.get('portalDescription') ? this.model.get('portalDescription') : this.model.get('description'),
							bind: 'reviewInfo',
							dataType: 'System.String',
							type: 'TextBox',
							displayOnly: true,
							isHtml: true,
							value: i18n.t('CIVICS.COMMON.ID') + ' ' + this.model.get('id') + ' | '
								+ i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SERIES_NUMBER_PREFIX', { seriesNumber: this.model.get('subTypeNumber') })
						}
					]
				},
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SCHEDULED_DATE'),
					dataType: 'System.String',
					type: 'TextBox',
					displayOnly: true,
					isVisible: true, 
					value: this.config.captureRequestDateToCallDate ? Handlebars.helpers['global:formatDate'](this.model.get('callDateTime'))
								: Handlebars.helpers['global:formatDate'](this.model.get('scheduledDateTime'))
				},
				{
					text: i18n.t('CIVICS.COMMON.SITE'),
					dataType: 'Text',
					type: 'TextBox',
					displayOnly: true,
					isVisible: this.showSiteData(),
					//put in a max length to make sure th value is treated as a multiline box, and has the BR processed appropriately.
					maxLength:300,
					value: this.getLocation(),
				},
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.MESSAGE'),
					dataType: 'Text',
					bind: 'comments',
					type: 'TextBox',
					maxLength: 300,
					fieldContainerClass:'full-width',
					placeholderText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.TYPE_OPTIONAL_MESSAGE'),
					isVisible: true,
					optionalText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.OPTIONAL')
				},
			]
		},
		getLocation: function()
		{
			if(this.model.get('instrument')) {
				if(this.model.get('instrument.locationLine1') != "")
				{
					return this.model.get('instrument.locationLine1') + '</br>' + this.model.get('instrument.locationLine2');
				} else {
					return this.model.get('instrument.locationLine4') + '</br>' + this.model.get('instrument.locationLine5');
				}
			}
			return '';
		},
		reviewCancelFormJSON: function () {
			var json = this.reviewDeclineFormJSON();
			json[0].text = i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.ABOUT_TO_CANCEL_REVIEW') + '</br></br>';
			return json;
		},
		inspectionDeclineFormJSON: function () {
			var json = this.reviewDeclineFormJSON();
			json[0].text = i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.ABOUT_TO_DECLINE_INSPECTION') + '</br></br>';
			//change the title and check which date value to use based on the config.
			json[2].text = i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.REQUESTED_DATE');
			if (this.config.captureRequestDateToCallDate) {
				json[2].value = Handlebars.helpers['global:formatDate'](this.model.get('callDateTime'))
			}
			//inspections have a time preference. splice it into the JSON after the scheduled date.
			json.splice(3, 0, {
				text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.REQUESTED_TIME'),
				bind: 'timePreference',
				dataType: 'System.String',
				moniker: 'Hansen.CDR.'+this.instrumentType+'.TimePreference',
				displayOnly:true,
				type: 'Textbox',
				value: this.model.get('timePreference'),
				optionalText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.OPTIONAL')
			});
			return json;
		},
		inspectionCancelFormJSON: function () {
			var json = this.reviewDeclineFormJSON();
			json[0].text = i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.ABOUT_TO_CANCEL_INSPECTION') + '</br></br>';
			//inspections have a time preference. splice it into the JSON after the scheduled date.
			json.splice(3, 0, {
				text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SCHEDULED_TIME'),
				bind: 'timePreference',
				dataType: 'System.String',
				moniker: 'Hansen.CDR.'+this.instrumentType+'.TimePreference',
				displayOnly: true,
				type: 'Textbox',
				value: this.model.get('timePreference'),
				optionalText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.OPTIONAL')
			});
			return json;
		},
		inspectionScheduleFormJSON: function () {
			var json = [
				{
					text: '<h3>' + i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.DETAILS_FOR_REQUEST') + '</h3>',
					type: 'label',
					isHtml: true
				},
				{
					type: 'Panel',
					elements: [
						{
							text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.PARTIAL_INSPECTION'),
							bind: 'isPartial',
							type: 'Checkbox',
							value: this.model.get('isPartial')
						}
					]
				},
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.REQUESTED_DATE'),
					bind: 'scheduledDateTime',
					dataType: 'System.DateTime',
					isRequired: true,
					format: 'date',
					type: 'TextBox',
					value: this.config.captureRequestDateToCallDate ? this.model.get('callDateTime') : this.model.get('scheduledDateTime')
				},
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.REQUESTED_TIME'),
					bind: 'timePreference',
					dataType: 'System.String',
					moniker: 'Hansen.CDR.'+this.instrumentType+'.TimePreference',
					type: 'Textbox',
					value: this.model.get('timePreference'),
					optionalText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.OPTIONAL')
				},

			]
			if (AvailableFeatures.SpecialInstructions()) {
				json.push({
					type: 'Panel',
					elements: [
						{
							text: '<h3>' + i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SPECIAL_INSTRUCTIONS_FOR_REQUEST') + '</h3></br>',
							type: 'label',
							isHtml: true
						}
					]
				},
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.CONTACT_PERSON'),
					bind: 'contactPerson',
					type: 'TextBox',
					value: this.model.get('contactPerson'),
					maxLength: 100,
					description: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.TOOLTIPS.CONTACT_PERSON')
				},
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.CONTACT_INFORMATION'),
					bind: 'contactInfo',
					type: 'TextBox',
					value: this.model.get('contactInfo'),
					maxLength: AvailableFeatures.MaxInspContactInfoLength(),
					description: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.TOOLTIPS.CONTACT_INFO')
				},
				{
					text: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SPECIAL_INSTRUCTIONS'),
					bind: 'specialInstructions',
					type: 'TextBox',
					value: this.model.get('specialInstructions'),
					maxLength: 300,
					description: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.TOOLTIPS.INSTRUCTIONS'),
					placeholderText: i18n.t('CIVICS.MY_ASSIGNMENTS_CARD_VIEW.SPECIAL_INSTRUCTIONS_PLACEHOLDER')
				}
				);
			}
			return json;
		},
		inspectionRescheduleFormJSON: function () {
			return this.inspectionScheduleFormJSON();
		},
		showSiteData:function(){
			//this method works for my assignments card view portlet
			let instrumentType = this.model.get('instrument.instrumentType') ? this.model.get('instrument.instrumentType').toLowerCase(): "";
			if(instrumentType === "") {
				//this method works for the instrument details portlet
				instrumentType = this.model.get('type') ? this.model.get('type').toLowerCase() : "";
			}
			return instrumentType != "tradelicense";
		},

		reviewButtons: {
			hasResult: [
				{
					openElectronicPlan: true
				},
				{
					viewDetails: true
				}
			],
			hasScheduledDate: [
				{
					openElectronicPlan: true
				},
				{
					recordResults: true
				},
				{
					reschedule: true
				},
				{
					cancel:true
				},
				{
					viewDetails: true
				}
			],
			hasNothing: [
				{
					accept: true
				},
				{
					decline: true
				},
				{
					viewDetails: true
				}
			]
		},
		inspectionButtons: {
			hasResult: [
				{
					viewDetails: true
				}
			],
			hasScheduledDate: [
				{
					recordResults: true
				},
				{
					reschedule: true
				},
				{
					cancel: true
				},
				{
					viewDetails: true
				}
			],
			hasRequestDate: [
				{
					accept: true
				},
				{
					decline: true
				},
				{
					viewDetails: true
				}
			],
			hasNothing: [
				{
					accept: true
				},
				{
					decline: true
				},
				{
					viewDetails: true
				}
			]

		}
	}
});
